// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603050952/js/" + chunkId + "." + {"44":"572375a7","225":"83077f09","481":"754617f4","486":"59b29669","770":"50e2ebbb"}[chunkId] + ".0.7296196629082483.chunk.js";
};